import React from "react";
import "./OrderStatus.scss";

// SVG assets - using Figma design assets
const imgCalendarDots = "/assets/images/CalendarDotsActive.png";
const imgFrame1410126600 = "/assets/images/HandCoins.png";
const imgHandCoinsActive = "/assets/images/HandCoinsActive.png";
const imgFrame1410126602 = "/assets/images/UserFocus.png";
const imgUserFocusActive = "/assets/images/UserFocusActive.png";
const imgFrame1410126603 = "/assets/images/Confetti.png";
const imgConfettiActive = "/assets/images/ConfettiActive.png";
const imgFrame1410126604 = "/assets/images/MoneyWavyPending.png";
const imgMoneyWavyActive = "/assets/images/MoneyWavyActive.png";
const imgVector322 = "/assets/images/progress-line.svg";

const OrderStatus = ({ currentStatus, isPaymentCompleted = false }) => {
  const stages = [
    {
      id: "submitted",
      label: "Booking Received",
      icon: imgCalendarDots,
      className: "stage-submitted",
    },
    {
      id: "assigned",
      label: "Pujari Assigned",
      icon: imgFrame1410126602,
      className: "stage-assigned",
    },
    {
      id: "samagiri-payment",
      label: "Partially Paid/Puja Confirmed",
      icon: imgFrame1410126600,
      className: "stage-samagiri-payment",
    },
    {
      id: "puja-completed",
      label: "Puja Completed",
      icon: imgFrame1410126603,
      className: "stage-puja-completed",
    },
    {
      id: "payment-completed",
      label: "Payment Completed",
      icon: imgFrame1410126604,
      className: "stage-payment-completed",
    },
  ];

  const getCompletedStages = () => {
    const statusOrder = {
      submitted: [],
      pujari_assigned: ["submitted"],
      puja_confirmed: ["submitted", "assigned"],
      puja_ended: ["submitted", "assigned", "samagiri-payment"],
      payment_completed: [
        "submitted",
        "assigned",
        "samagiri-payment",
        "puja-completed",
      ],
    };

    let completedStages = statusOrder[currentStatus] || [];

    if (isPaymentCompleted) {
      completedStages = [
        "submitted",
        "assigned",
        "samagiri-payment",
        "puja-completed",
      ];
    }

    return completedStages;
  };

  const completedStages = getCompletedStages();

  const statusMapping = {
    submitted: "submitted",
    pujari_assigned: "assigned",
    puja_confirmed: "samagiri-payment",
    puja_ended: "puja-completed",
    payment_completed: "payment-completed",
  };

  const getStageState = (stageId) => {
    // If payment is completed through API, payment-completed stage should be active
    if (isPaymentCompleted && stageId === "payment-completed") {
      return "active";
    }

    // If payment is completed, all other stages should be completed
    if (isPaymentCompleted && stageId !== "payment-completed") {
      return "completed";
    }

    // If current status matches this stage, it should be active
    if (statusMapping[currentStatus] === stageId) {
      return "active";
    }

    // If this stage should be completed based on current status
    if (completedStages.includes(stageId)) {
      return "completed";
    }

    return "pending";
  };

  return (
    <div className="order-status-container">
      <div className="order-status-tracker">
        {/* Stages */}
        {stages.map((stage) => (
          <div
            key={stage.id}
            className={`status-stage ${stage.className} ${getStageState(
              stage.id
            )}`}
          >
            <div className="status-icon">
              <div className="icon-container">
                <div className="relative size-full">
                  <img
                    src={
                      stage.id === "assigned" &&
                      (getStageState(stage.id) === "active" ||
                        getStageState(stage.id) === "completed")
                        ? imgUserFocusActive
                        : stage.id === "samagiri-payment" &&
                          (getStageState(stage.id) === "active" ||
                            getStageState(stage.id) === "completed")
                        ? imgHandCoinsActive
                        : stage.id === "puja-completed" &&
                          (getStageState(stage.id) === "active" ||
                            getStageState(stage.id) === "completed")
                        ? imgConfettiActive
                        : stage.id === "payment-completed" &&
                          (getStageState(stage.id) === "active" ||
                            getStageState(stage.id) === "completed")
                        ? imgMoneyWavyActive
                        : stage.icon
                    }
                    alt=""
                    className="block max-w-none size-full tw-h-[27px] tw-w-[27px] tw-mt-[12px] tw-ml-[12px]"
                  />
                </div>
              </div>
            </div>
            <div className="status-label">
              <p>{stage.label}</p>
            </div>
          </div>
        ))}

        {/* Progress lines - connecting 5 stages (4 lines for 5 stages) */}
        <div className="progress-line progress-line-0">
          <div className="absolute bottom-[-0.5px] left-0 right-0 top-[-0.5px]">
            <img
              alt=""
              className="block max-w-none size-full"
              src={imgVector322}
            />
          </div>
        </div>
        <div className="progress-line progress-line-1">
          <div className="absolute bottom-[-0.5px] left-0 right-0 top-[-0.5px]">
            <img
              alt=""
              className="block max-w-none size-full"
              src={imgVector322}
            />
          </div>
        </div>
        <div className="progress-line progress-line-2">
          <div className="absolute bottom-[-0.5px] left-0 right-0 top-[-0.5px]">
            <img
              alt=""
              className="block max-w-none size-full"
              src={imgVector322}
            />
          </div>
        </div>
        <div className="progress-line progress-line-3">
          <div className="absolute bottom-[-0.5px] left-0 right-0 top-[-0.5px]">
            <img
              alt=""
              className="block max-w-none size-full"
              src={imgVector322}
            />
          </div>
        </div>
        <div className="progress-line progress-line-4">
          <div className="absolute bottom-[-0.5px] left-0 right-0 top-[-0.5px]">
            <img
              alt=""
              className="block max-w-none size-full"
              src={imgVector322}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderStatus;
